// ContentDivider wrapper that extends SectionDivider with additional props
import type { HTMLAttributes, ReactNode } from "react"

import { cx } from "@/utils/cx"

interface ContentDividerProps extends HTMLAttributes<HTMLDivElement> {
  type?: "single-line" | "double-line"
  children?: ReactNode
}

export const ContentDivider = ({
  type = "single-line",
  className,
  children,
  ...props
}: ContentDividerProps) => {
  if (children) {
    return (
      <div {...props} className={cx("flex items-center gap-4", className)}>
        <hr className="bg-border-secondary h-px flex-1 border-none" />
        {children}
        <hr className="bg-border-secondary h-px flex-1 border-none" />
      </div>
    )
  }

  return (
    <div
      {...props}
      className={cx("max-w-container mx-auto px-4 md:px-8", className)}
    >
      <hr className="bg-border-secondary h-px w-full border-none" />
      {type === "double-line" && (
        <hr className="bg-border-secondary mt-1 h-px w-full border-none" />
      )}
    </div>
  )
}
